export default {
  currentPage(state, value) {
    return (state.currentPage = value);
  },

  tableLoading(state, value) {
    return (state.tableLoading = value);
  },

  perPage(state, value) {
    return (state.perPage = value);
  },
  payload(state, value) {
    return (state.payload = value);
  },
  total(state, value) {
    return (state.total = value);
  },
  tableHeading(state, value) {
    return (state.tableHeading = value);
  },
  employeeReports(state, value) {
    return (state.employeeReports = value);
  },
};
